import RouterView from '@/components/layout/Router.vue';
import { teamPlayerContainerRoute } from './player/playerContainer.route';
import { teamPlayersRoute } from './player/players.route';

export const teamPlayersContainerRoute = {
  path: 'players',
  component: RouterView,
  meta: { title: 'titles.team.players' },
  children: [teamPlayersRoute, teamPlayerContainerRoute]
};
